import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Download Istantaneo', 'Nessun Abbonamento', 'Accesso a Vita', 'Garanzia di 14 Giorni'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-104" data-mp="9lbfcytwl7cj">
      <div className="mx-auto max-w-4xl text-center" data-id="element-105" data-mp="4m8l89fgoljc">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-106" data-mp="4jm53lei8xpi">
          Risolvi un Intero Anno di Lezioni di Ginnastica Artistica in soli{' '}
          <span className="italic text-brand" data-id="element-107" data-mp="nbyhl0yvhfdd">5 Minuti</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-108" data-mp="3d2bhzk51cpsw">
          Unisciti a oltre 1.500 istruttori che hanno smesso di improvvisare in
          pedana. Entra in palestra con tutto pronto per insegnare, correggere e
          ispirare.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-109" data-mp="3e8efj63mtg2w">
          <img src="https://cdn.magicpatterns.com/uploads/4pc4Nr6Umrzcn1VjgZ7iwC/c7367f98-8545-4bfe-9e1b-6d34a03b608a.webp" alt="Il pacchetto GINNASTICA ARTISTICA PRONTA: i sei volumi dal Gioco-Sport all'Avanzato con il Manager Plan, la piattaforma su desktop, tablet e smartphone e i 5 bonus inclusi" className="mx-auto w-[92%] max-w-2xl sm:w-[88%]" data-id="element-110" data-mp="2qk3kwkoj4cn2" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-111" data-mp="s2b89zesml5o">
          <CtaButton href="#offer" data-id="element-112" data-mp="icro8qfcgl98" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-113" data-mp="dd5cklf5zd2j">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-114" data-mp="1ayt68yk8jhad" data-mpi={index}>
                <span data-id="element-115" data-mp="16345irwhbuch">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-116" data-mp="111omt6hrxzx9">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}